import { css } from "@emotion/react";

export const background = css`
  background-color: var(--color-secondary);
`;

export const container = css`
  padding: 80px 0;
  @media (min-width: 600px) {
    padding: 128px 0;
  }
`;

export const introductionTitle = css`
  font-size: 30px;
  line-height: 1.2;
  color: var(--color-white);
  @media (min-width: 600px) {
    font-size: 50px;
  }
`;

export const introductionDescription = css`
  margin-top: 24px;
  font-size: 14px;
  font-weight: 300;
  line-height: 22.4px;
  color: var(--color-white);
  @media (min-width: 600px) {
    font-size: 24px;
    line-height: 38.4px;
  }
`;

export const subDescription = css`
  ${introductionDescription}
  margin-top: 48px;
`;

export const endTitle = css`
  margin-top: 16px;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--color-white);
  @media (min-width: 600px) {
    font-size: 50px;
  }
`;
